import { Checkbox, FormControlLabel, FormGroup, Stack, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { RealityInput, useRealitiesDataQuery } from '../../../../../../../gql';
import { useIntl } from 'react-intl';

interface Props {
  stepIndex: number;
  activeStep: number;
  onStepComplete: () => void;
}

export const ApproachStep: React.FC<Props> = () => {
  const realitiesQuery = useRealitiesDataQuery();
  const { formatMessage } = useIntl();

  const { control } = useFormContext<RealityInput>();
  const approachIds = useWatch({ control, name: 'approachIds' });

  // Find the "Other" option (system option)
  const otherOption = realitiesQuery.data?.approaches.find((a) => a.isSystemOption);
  const isOtherSelected = otherOption && approachIds?.includes(otherOption.id);

  return (
    <Stack spacing={2}>
      <Controller
        name="approachIds"
        control={control}
        render={({ field }) => (
          <FormGroup>
            {realitiesQuery.data?.approaches.map((approach, index) => (
              <FormControlLabel
                key={approach.id}
                name={`${field.name}[${index}]`}
                control={<Checkbox checked={field.value && field.value.includes(approach.id)} />}
                onChange={(e, checked) => {
                  if (checked) {
                    field.onChange([...field.value, approach.id]);
                  } else {
                    field.onChange(
                      field.value.filter((item) => item !== approach.id)
                    );
                  }
                }}
                label={approach.name} />
            ))}
          </FormGroup>
        )}
      />

      {isOtherSelected && (
        <Controller
          name="approachOtherValue"
          control={control}
          rules={{ required: formatMessage({ id: 'Please specify the other approach' }) }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={formatMessage({ id: 'Please specify' })}
              placeholder={formatMessage({ id: 'Describe the other approach' })}
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      )}
    </Stack>
  );
};